import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@/components/common/Button/Button';
import MotionDiv from '@/components/common/Motion/MotionDiv';
import { PiPlus } from 'react-icons/pi';

interface Props {
  className?: string;
  month?: string | null;
}

const CommissionWidget = ({ className = '', month = null }: Props) => {
  const { t } = useTranslation();

  return (
    <MotionDiv delay={0.2} key={`${month}-null`}>
      <Link
        to={'/bolt/commission'}
        state={{ month }}
        className={`relative flex flex-col bg-zinc-100 rounded-2xl px-4 py-5 flex items-center overflow-hidden ${className}`}>
        <p
          className="font-medium text-center text-base text-base-black w-[16.562rem] mb-3 leading-[1.3] tracking-[0.01rem]">
          {t('dashboard.widgets.uploadCommissionInvoice')}
        </p>
        <Button variant='secondary' className='py-[0.25rem] px-[1rem] h-9'>
          <span className='font-semibold text-blue-600 flex items-center gap-2'>
            <PiPlus className="h-6 w-6" />
            {t('dashboard.widgets.uploadDocument')}
          </span>
        </Button>
      </Link>
    </MotionDiv>
  );
};

export default CommissionWidget
